import Link from 'next/link';
import * as React from 'react';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /**
   * The URL to link to.
   */
  link: string;

  /**
   * The target of the anchor:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target.
   *
   * @defaultValue "_self"
   */
  target?: '_self' | '_blank';

  /**
   * The onClick handler. Can be used to pass an optional callback that will be
   * invoked on click.
   */
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;

  /**
   * Whether the browser should scroll up to the top upon navigating to a new
   * page.
   *
   * @defaultValue true
   */
  scroll?: boolean;

  /**
   * Indicates the element that represents the current item within a container
   * or set of related elements:
   * https://www.w3.org/TR/wai-aria-1.1/#aria-current.
   */
  'aria-current'?: React.AriaAttributes['aria-current'];

  /**
   * The children elements.
   */
  children: React.ReactNode | React.ReactNode[];

  className?: string;

  href: string;
}

const NextLink: React.FC<LinkProps> = ({
  href,
  target = '_self',
  onClick,
  scroll = true,
  children,
  className,
  ...rest
}) => {
  return (
    <Link href={href} scroll={scroll} onClick={onClick} target={target} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default NextLink;
